import { LocalStorageKey } from 'shared/constants/localStorage'
import { LocalStorageValue } from 'shared/types/localStorage'

export const lsSetItem = <T extends LocalStorageKey>(
  key: T,
  value: LocalStorageValue[T]
) => {
  localStorage.setItem(
    key,
    typeof value === 'string' ? value : JSON.stringify(value)
  )
}
